<template>
  <div>
    <b-row>
      <b-col md="12">
        <h4>Sites Dashboard</h4>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col md="12">
        <b-button variant="primary" class="mx-1" :to="{name: 'sites'}" exact>View Active Sites</b-button>
        <b-button variant="primary" class="mx-1" :to="{name: 'siteAdd'}" v-if="isSitesManager" exact>Add Site</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <widget heading="Semester Totals">
        <items-per-term :items="semesterTotals"/>
        </widget>
      </b-col>
      <b-col></b-col>
        
      <b-col></b-col>
    </b-row>
  </div>
</template>

<script>
// import ContractsDashboard from "../../components/dashboard/contracts-dashboard";
import roleChecks from "@/misc/role-checks";
import opportunityReportsApi from "../../api/opportunityReporting";
import ItemsPerTerm from "../../components/dashboard/items-per-term";
export default {
  mixins: [roleChecks],
  data() {
    return {
      semesterTotals: {}
    };
  },

  components: {
    ItemsPerTerm
  },

  computed: {},

  created() {
    opportunityReportsApi.getSitesPerSemester().then(response => {
      this.semesterTotals = response.data;
    });
  }
};
</script>

<style scoped>
.dashboard {
  margin-bottom: 30px;
}
.btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
}

.card-body {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
